var path = '/pages/guestlists/components/messages/rsvp-messages.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/components/messages/rsvp-messages.tpl.html
// module id = 2253
// module chunks = 1